import Customer from './contentSummary/Customer';
import Payment from './contentSummary/Payment';

const ContentSummary = (props) => {
  const { reservationCart, customer, currentStep, onEdit } = props;
  if (currentStep === 'customer') {
    return null;
  }
  return (
    <div className="c7-checkout__content__summary">
      <Customer
        reservationCart={reservationCart}
        customer={customer}
        currentStep={currentStep}
        onEdit={onEdit}
      />
      <Payment
        reservationCart={reservationCart}
        currentStep={currentStep}
        onEdit={onEdit}
      />
    </div>
  );
};
export default ContentSummary;
